import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { ETF_FUND, CLOSED_END_FUND } from '../../Helpers/FundTypes'
import { formatDateStandard } from '../../../../global/formatters/string-formatter'
import {
  getTooltipContentByKey,
  getVariablePortfolioTooltipContent,
} from '../../../Tooltip/tooltipUtil'
import Tooltip from '../../../Tooltip/Tooltip.jsx'

function OverviewFees({ feesAndExpenses, fundGroup }) {
  const variablePortfolioTooltipData = getVariablePortfolioTooltipContent()

  return (
    <div
      className="u-borderColorNeutralLight u-borderBottom0 u-borderTop0 u-borderLeft u-borderRight0 u-paddingLeft4gu u-sm-decoBorderReset u-sm-paddingLeft0 u-sm-paddingTop6gu"
      id="fees"
    >
      <div className="Content Fees u-paddingVert0">
        <h3 className="u-marginTop0">Fees</h3>
        <ul className="u-marginBottom0 u-marginLeft0">
          {fundGroup !== CLOSED_END_FUND && (
            <li className="u-decoUnbulleted u-marginHoriz0 u-marginBottom3gu u-sm-posRelative">
              <Tooltip
                heading={
                  getTooltipContentByKey(
                    variablePortfolioTooltipData,
                    'Net Expense Ratio'
                  )?.heading || 'Net Expense Ratio'
                }
                content={
                  getTooltipContentByKey(
                    variablePortfolioTooltipData,
                    'Net Expense Ratio'
                  )?.content || ''
                }
                direction="Tooltip-left"
                id="net-expense-ratio-info"
              >
                <h4>
                  <span className="u-textColorLight u-textSecondary Tooltip-label">
                    Net Expense Ratio
                  </span>
                  <span className="Icon--material Tooltip-icon u-marginLeft1gu">
                    info
                  </span>
                </h4>
              </Tooltip>
              {feesAndExpenses.expenseNet && (
                <p className="u-textSizeMsrp3 u-textSecondary u-sm-textSizeMsrp1 u-marginBottom0">
                  {feesAndExpenses.expenseNet}%
                </p>
              )}
              {feesAndExpenses.cappedExpense && (
                <p className="u-textSizeMsrp3 u-textSecondary u-sm-textSizeMsrp1">
                  {feesAndExpenses.cappedExpense}%
                </p>
              )}
              <p className="u-textColorLight u-textSizeMsrm1 u-textSecondary">
                as of {formatDateStandard(feesAndExpenses.expenseAsOfDate)}
              </p>
            </li>
          )}
          {fundGroup !== CLOSED_END_FUND && (
            <li className="u-decoUnbulleted u-marginHoriz0 u-marginBottom3gu u-sm-posRelative">
              <Tooltip
                heading={
                  getTooltipContentByKey(
                    variablePortfolioTooltipData,
                    'Gross Expense Ratio'
                  )?.heading || 'Gross Expense Ratio'
                }
                content={
                  getTooltipContentByKey(
                    variablePortfolioTooltipData,
                    'Gross Expense Ratio'
                  )?.content || ''
                }
                direction="Tooltip-left"
                id="net-expense-ratio-info"
              >
                <h4>
                  <span className="u-textColorLight u-textSecondary Tooltip-label">
                    Gross Expense Ratio
                  </span>
                  <span className="Icon--material Tooltip-icon u-marginLeft1gu">
                    info
                  </span>
                </h4>
              </Tooltip>
              {feesAndExpenses.grossExpense && (
                <p className="u-textSizeMsrp3 u-textSecondary u-sm-textSizeMsrp1 u-marginBottom0">
                  {feesAndExpenses.grossExpense}%
                </p>
              )}
              <p className="u-textColorLight u-textSizeMsrm1 u-textSecondary">
                as of {formatDateStandard(feesAndExpenses.expenseAsOfDate)}
              </p>
            </li>
          )}
          {fundGroup == ETF_FUND && feesAndExpenses.expenseRatioWaiverDate && (
            <li className="u-decoUnbulleted u-marginHoriz0 u-marginBottom3gu u-sm-posRelative">
              <h4>
                <span className="u-textColorLight u-textSecondary">
                  Waiver Expiration Date
                </span>
              </h4>
              {feesAndExpenses.expenseRatioWaiverDate && (
                <p className="u-textSizeMsrp3 u-textSecondary u-sm-textSizeMsrp1 u-marginBottom0">
                  {formatDateStandard(feesAndExpenses.expenseRatioWaiverDate)}
                </p>
              )}
            </li>
          )}
          {fundGroup === CLOSED_END_FUND && (
            <li className="u-decoUnbulleted u-marginHoriz0 u-marginBottom3gu">
              <h4>Total Annual Expense</h4>
              {feesAndExpenses.annualExpense && (
                <p className="u-textSizeMsrp3 u-textSecondary u-sm-textSizeMsrp1 u-marginBottom0">
                  {feesAndExpenses.annualExpense}%
                </p>
              )}
              <p className="u-textColorLight u-textSizeMsrm1 u-textSecondary">
                as of {formatDateStandard(feesAndExpenses.expenseAsOfDate)}
              </p>
            </li>
          )}
          {fundGroup !== ETF_FUND && fundGroup !== CLOSED_END_FUND && (
            <Fragment>
              <li className="u-decoUnbulleted u-marginHoriz0 u-marginBottom3gu">
                <h4>Maximum Sales Charge or CDSC</h4>
                {feesAndExpenses.maxSalesCharge === '-' ? (
                  <p className="u-textSizeMsrp3 u-textSecondary u-sm-textSizeMsrp1 u-marginBottom0">
                    {feesAndExpenses.maxSalesCharge}
                  </p>
                ) : (
                  <p className="u-textSizeMsrp3 u-textSecondary u-sm-textSizeMsrp1 u-marginBottom0">
                    {feesAndExpenses.maxSalesCharge}%
                  </p>
                )}
                <p className="u-textColorLight u-textSizeMsrm1 u-textSecondary">
                  as of {formatDateStandard(feesAndExpenses.expenseAsOfDate)}
                </p>
              </li>

              <a
                className="js-subnav-link Link u-textSecondary"
                href="#fees-expenses"
              >
                View more
              </a>
            </Fragment>
          )}
        </ul>
      </div>
    </div>
  )
}

OverviewFees.propTypes = {
  feesAndExpenses: PropTypes.object.isRequired,
  fundGroup: PropTypes.string.isRequired,
}

export default OverviewFees
